import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"

import "./Message.vue?vue&type=style&index=0&id=4465bfb4&scoped=true&lang=scss"

import exportComponent from "E:\\七田\\QTEducationSml\\03 开发代码\\SmlSys\\SmlPc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4465bfb4"]])

export default __exports__